/*
  Fuego & Fragancia — Our Story.

  Dos cosas pequeñas alrededor del video de la fundadora:

  1. El botón de sonido. Los navegadores solo permiten que un video arranque
     solo si está en silencio, así que el video nace mudo y hace falta un gesto
     del visitante para darle voz. Sin este botón el mensaje de Dora no se
     oiría nunca.

  2. Pausarlo cuando no se ve. Un vertical reproduciéndose en bucle a mitad de
     la página gasta batería y datos aunque nadie lo esté mirando.
*/
(function () {
  function conectar(raiz) {
    raiz.querySelectorAll('.ff-our-story').forEach((seccion) => {
      if (seccion.dataset.ffStoryReady === 'true') return;
      seccion.dataset.ffStoryReady = 'true';

      const video = seccion.querySelector('.ff-our-story__video');
      if (!video) return;

      const boton = seccion.querySelector('.ff-our-story__sound');
      if (boton) {
        boton.setAttribute('aria-pressed', video.muted ? 'false' : 'true');
        boton.addEventListener('click', () => {
          const activandoSonido = video.muted;
          video.muted = !video.muted;
          boton.setAttribute('aria-pressed', video.muted ? 'false' : 'true');

          if (activandoSonido) {
            // Se vuelve a empezar desde el principio. El video lleva rato
            // girando en silencio, así que al darle voz el visitante caería en
            // mitad de una frase y se perdería el mensaje de Dora entero.
            video.currentTime = 0;
            video.play().catch(() => {});
          }
        });
      }

      if (!video.hasAttribute('autoplay')) return;

      const observador = new IntersectionObserver(
        (entradas) => {
          entradas.forEach((entrada) => {
            if (entrada.isIntersecting) {
              video.play().catch(() => {});
            } else if (!video.paused) {
              // `pause()` y no `muted`: quien ya activó el sonido espera
              // volver a oírlo al regresar, no encontrárselo mudo.
              video.pause();
            }
          });
        },
        { threshold: 0.25 }
      );
      observador.observe(video);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => conectar(document));
  } else {
    conectar(document);
  }

  // El Theme Editor vuelve a pintar la sección en cada cambio de ajuste y el
  // marcador `ffStoryReady` se va con el HTML viejo, así que se reconecta sola.
  document.addEventListener('shopify:section:load', (event) => conectar(event.target));
})();
